export default "__VITE_ASSET__Dsl1BJmR__"